import { render, staticRenderFns } from "./403-page.vue?vue&type=template&id=bfee1cac&scoped=true"
import script from "./403-page.vue?vue&type=script&lang=js"
export * from "./403-page.vue?vue&type=script&lang=js"
import style0 from "./403-page.vue?vue&type=style&index=0&id=bfee1cac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfee1cac",
  null
  
)

export default component.exports